import { ListingLevel } from '@deltek/specification-client/core/Models/product'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

interface TabContentProps {
    type?: ListingLevel
}

const useStyles = makeStyles((theme) => ({
    tabContainer: {
        margin: theme.spacing(6, 1.5),
    },
    tabButton: {
        color: '#304959',
        textTransform: 'uppercase',
        backgroundColor: 'transparent',
        margin: theme.spacing(0, 1.5),
        '&:hover': {
            backgroundColor: 'transparent',
        },
        fontSize: pxToRem(13),
        fontWeight: 400,
    },
    tabButtonActive: {
        color: theme.palette.common.white,
        margin: theme.spacing(0, 1.5),
        boxShadow:
            '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
        padding: theme.spacing(1, 2),
        textTransform: 'uppercase',
        backgroundColor: '#304959',
        '&:hover': {
            backgroundColor: '#304959',
        },
        fontSize: pxToRem(13),
        fontWeight: 400,
    },
}))

export const TabContent: React.FC<TabContentProps> = ({ children }) => {
    return <>{children}</>
}
